import API from 'api';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAdvisorTypes } from 'Reducers/advisorTypesReducer';

const useAdvisorTypes = () => {
    const dispatch = useDispatch();
    const advisorTypes = useSelector((state) => state.advisorTypes.data);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (advisorTypes) return; // Don't fetch again

        // setLoading(true);
        API.advisor.getAdvisorTypes()
            .then((res) => {
                dispatch(setAdvisorTypes(res));
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [advisorTypes, dispatch]);

    return { advisorTypes, loading, error };
};

export default useAdvisorTypes;
